export const THEME_STORAGE_KEY = 'kyrgyzkomur.theme'
export const DEFAULT_THEME = 'light'

export function normalizeTheme(value) {
  return value === 'dark' ? 'dark' : DEFAULT_THEME
}

export function themeUserKey(userId) {
  return userId === undefined || userId === null || userId === ''
    ? THEME_STORAGE_KEY
    : `${THEME_STORAGE_KEY}.user.${userId}`
}

export function readTheme(userId, storage) {
  try {
    storage = storage || window.localStorage
    return normalizeTheme(storage.getItem(themeUserKey(userId)) || storage.getItem(THEME_STORAGE_KEY))
  } catch {
    return DEFAULT_THEME
  }
}

export function saveTheme(theme, userId, storage) {
  const value = normalizeTheme(theme)
  try {
    storage = storage || window.localStorage
    storage.setItem(themeUserKey(userId), value)
    storage.setItem(THEME_STORAGE_KEY, value)
  } catch {
    // The current session still works when browser storage is unavailable.
  }
  return value
}

export function applyTheme(theme) {
  if (typeof document === 'undefined') return
  const value = normalizeTheme(theme)
  document.documentElement.dataset.theme = value
  document.documentElement.style.colorScheme = value
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) meta.content = value === 'dark' ? '#333333' : '#ffffff'
}

if (typeof window !== 'undefined') applyTheme(readTheme())
